import { getDetailQuery, getDetailRoute } from '@features/rates/helpers/bookingRoutes.helper';
import { useRouter } from 'shared-routing';
import { StepTypeWithIndex } from '../../types';

export const usePreviousStep = (rateCode: string, currentStep: StepTypeWithIndex) => {
  const router = useRouter();

  return () => {
    if (currentStep.index > 0) {
      return router.back();
    }

    return router.push({
      pathname: getDetailRoute(router.pathname),
      query: getDetailQuery(router.query, rateCode),
    });
  };
};
